export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[960px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-primary-100 text-primary-700 mb-3 whitespace-nowrap">
            关于窝窝
          </span>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">
            用心做好每一次观影体验
          </h2>
        </div>
        <div className="bg-background-100 rounded-xl p-8 md:p-10">
          <p className="text-foreground-700 text-sm md:text-base leading-relaxed mb-4">
            窝窝影院成立于 2020 年，是国内领先的高清免费在线观影平台。我们始终秉持<strong className="text-foreground-900">"让每个人都能轻松享受高品质观影"</strong>的初心，通过持续的技术创新和内容运营，为用户提供高清播放、在线不缓冲的流畅观影体验。
          </p>
          <p className="text-foreground-700 text-sm md:text-base leading-relaxed mb-4">
            平台汇聚海量高清电影电视剧资源，覆盖动作、喜剧、科幻、悬疑、爱情、动画、纪录片、综艺等全品类内容。我们采用先进的分布式 CDN 加速与智能解码技术，确保用户流畅观看超清画质无广告，无论使用何种设备都能获得一致的高清体验。
          </p>
          <p className="text-foreground-700 text-sm md:text-base leading-relaxed mb-4">
            专业的内容团队 7×24 小时不间断更新片源，每日更新不卡顿，让海量高清电影电视剧免费在线观看成为日常。从院线新片到经典老片，从国产热播到海外精选，窝窝影院致力于打造最全面的在线影库，成为您身边最值得信赖的观影伙伴。
          </p>
          <p className="text-foreground-700 text-sm md:text-base leading-relaxed">
            截至目前，窝窝影院已累计服务超过千万用户，日均播放量突破百万次。未来我们将继续深耕内容质量与播放技术，不断优化产品体验，让每一位用户都能在窝窝影院找到属于自己的观影乐趣。窝窝影院——您的私人影院，随时随地，精彩在线。
          </p>
        </div>
      </div>
    </section>
  );
}